export default __webpack_public_path__ + "static/media/b2_lan-min.d54fc0e8.jpg";